import React, { useState } from "react";
import Navigation from "./Navigation";
import styles from './Navbar.module.css';
import { Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";


const Navbar = () => {

    const [searchClicked, setSearch] = useState(false);
    const searchClickHandler = () => {
        setSearch(true);
    }

    const crossClickHandler = () => {
        setSearch(false);
    }


    const location = useLocation();
    // console.log(location.pathname);
    const onProductsPage = (location.pathname === '/products');


    return (
        <div className={styles['navbar']}>

            <div className={styles['navbar-center-1']}>
                <Link to='/home'>
                    <div className={searchClicked ? styles["hidden"] : styles['app-logo']} >
                        <svg width="92" height="35" viewBox="0 0 92 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="1" width="27" height="9" rx="4.5" fill="#328fdb" />
                            <path d="M19.159 32.61C18.6223 33.2387 17.9937 33.714 17.273 34.036C16.5677 34.358 15.7933 34.519 14.95 34.519C13.846 34.519 12.834 34.266 11.914 33.76C10.994 33.2693 9.94367 32.4107 8.763 31.184C7.27567 31.0613 5.94167 30.632 4.761 29.896C3.58033 29.1447 2.66033 28.171 2.001 26.975C1.34167 25.7637 1.012 24.422 1.012 22.95C1.012 21.386 1.38767 19.9753 2.139 18.718C2.89033 17.4453 3.92533 16.4563 5.244 15.751C6.56267 15.0303 8.04233 14.67 9.683 14.67C11.3237 14.67 12.8033 15.0303 14.122 15.751C15.4407 16.4563 16.4757 17.4377 17.227 18.695C17.9783 19.9523 18.354 21.3707 18.354 22.95C18.354 24.2227 18.101 25.4033 17.595 26.492C17.089 27.5653 16.3837 28.4853 15.479 29.252C14.5743 30.0033 13.524 30.5477 12.328 30.885C12.7727 31.3603 13.2097 31.7053 13.639 31.92C14.0683 32.1347 14.5283 32.242 15.019 32.242C16.077 32.242 16.997 31.8127 17.779 30.954L19.159 32.61ZM4.025 22.95C4.025 24.0233 4.27033 24.997 4.761 25.871C5.25167 26.7297 5.92633 27.4043 6.785 27.895C7.64367 28.3703 8.60967 28.608 9.683 28.608C10.7563 28.608 11.7223 28.3703 12.581 27.895C13.4397 27.4043 14.1143 26.7297 14.605 25.871C15.0957 24.997 15.341 24.0233 15.341 22.95C15.341 21.8767 15.0957 20.9107 14.605 20.052C14.1143 19.178 13.4397 18.5033 12.581 18.028C11.7223 17.5373 10.7563 17.292 9.683 17.292C8.60967 17.292 7.64367 17.5373 6.785 18.028C5.92633 18.5033 5.25167 19.178 4.761 20.052C4.27033 20.9107 4.025 21.8767 4.025 22.95ZM29.0663 24.261L26.5133 26.883V31H23.5233V14.9H26.5133V23.157L34.4713 14.9H37.8293L31.0673 22.099L38.2433 31H34.7473L29.0663 24.261ZM52.0249 27.274H43.9749L42.3879 31H39.3059L46.5509 14.9H49.4949L56.7629 31H53.6349L52.0249 27.274ZM51.0359 24.928L47.9999 17.89L44.9869 24.928H51.0359ZM71.3444 31L68.0554 26.285C67.9174 26.3003 67.7104 26.308 67.4344 26.308H63.8004V31H60.8104V14.9H67.4344C68.8298 14.9 70.0411 15.13 71.0684 15.59C72.1111 16.05 72.9084 16.7093 73.4604 17.568C74.0124 18.4267 74.2884 19.4463 74.2884 20.627C74.2884 21.8383 73.9894 22.881 73.3914 23.755C72.8088 24.629 71.9654 25.2807 70.8614 25.71L74.5644 31H71.3444ZM71.2754 20.627C71.2754 19.5997 70.9381 18.81 70.2634 18.258C69.5888 17.706 68.5998 17.43 67.2964 17.43H63.8004V23.847H67.2964C68.5998 23.847 69.5888 23.571 70.2634 23.019C70.9381 22.4517 71.2754 21.6543 71.2754 20.627ZM82.6751 17.43H77.3391V14.9H91.0011V17.43H85.6651V31H82.6751V17.43Z" fill="#292B2E" />
                        </svg>
                    </div>
                </Link>

                {onProductsPage && false &&
                    <div className={`${searchClicked ? styles['search-section-1'] : styles['search-section-closed']} `}>
                        <div className={searchClicked ? styles['search-bar-1'] : ""}>
                            <div className={searchClicked ? styles["search-icon-container"] : ''} >
                                <i className={`fa fa-light fa-magnifying-glass ${styles['search-icon-1']}`} onClick={searchClickHandler}></i>
                            </div>
                            {searchClicked && <input type="text" name="search-input" className={styles['search-input-1']} placeholder='Search for shirt jeans ..' />}
                            {searchClicked && <i className=" fa fa-solid fa-x" id={styles["cross-icon-1"]} onClick={crossClickHandler}></i>}
                        </div>
                        {!searchClicked && <Navigation />}
                    </div>}

                {/* {!onProductsPage && <div className={styles['navbar-navigation']} >
                    <div className={styles['products-page-navigator']}  >
                        < NavLink to='/products' >
                            Products
                        </NavLink>
                    </div>
                    <Navigation />
                </div>} */}

                <div className={styles['navbar-navigation']} >
                    <div className={styles['products-page-navigator']}  >
                        < NavLink to='/products' >
                            Products
                        </NavLink>
                    </div>
                    <Navigation />
                </div>

            </div>

        </div >

    );
}

export default Navbar;